import { useConfirm } from 'material-ui-confirm';

/**
 * A reusable hook for confirmation dialogs in sidebars.
 * Provides consistent z-index configuration to ensure dialogs appear above sidebars.
 */
const useConfirmSidebar = () => {
    const confirm = useConfirm();

    const confirmSidebar = (options) => {
        return confirm({
            ...options,
            dialogProps: {
                sx: {
                    zIndex: 1450,
                    '& .MuiDialog-paper': {
                        zIndex: (theme) => 1450 + 1,
                    }
                },
                ...options.dialogProps
            }
        });
    };

    return confirmSidebar;
};

export default useConfirmSidebar;
